/*
 * Copyright (c) 2017 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

export class Site {
  id: string;
  description: string;
  published: boolean;
  name: string;
}
